import '../search-info/search-info.scss';
import React, {useCallback} from 'react';
import {
    useCurrentSortType,
    useSearchPageType,
    useStateDocs,
    useStateQuery,
    useStateQueryPending,
} from '../../search-hooks';
import {useDispatch, useSelector} from 'react-redux';
import {sortResults} from '../../duck/search-actions';
import {useTranslation} from 'react-i18next';
import {SearchSortType, SortOption, SortType} from '../../search-types';
import {SortDropdown} from '../../../common/sort-dropdown/sortDropdown';
import {useHistory} from 'react-router-dom';

export const SearchResultOverview = React.memo(() => {
    const searchPageType = useSearchPageType();
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const history: History = useHistory();

    const docs = useStateDocs();
    const query = useStateQuery();
    const queryPending = useStateQueryPending();
    const currentSortType = useCurrentSortType();
    const sortTypesFromConfiguration: SortType[] | undefined = useSelector((state) => state.search[searchPageType].sortTypes);

    const onSortChange = useCallback(
        (selectedOption: SortOption) => {
            const currentSortType = {field: selectedOption.value, order: selectedOption.order};
            dispatch(sortResults(searchPageType, currentSortType, history));
        },
        [searchPageType, dispatch, history]
    );

    const renderNoDocumentsFound = () => {
        return (
            <>
                {t('search.label.info.result_none', {searchPageType: searchPageType}) + ' '}
                <span className="highlight-query">{query}</span>
                <div className="search-hints">
                    <div className="search-hints-title">{t('search.label.info.search_hints_title')}</div>
                    <div className="search-hints-text">{t('search.label.info.search_hints_text1')}</div>
                    <div className="search-hints-text">{t('search.label.info.search_hints_text2')}</div>
                    <div className="search-hints-text">{t('search.label.info.search_hints_text3')}</div>
                </div>
            </>
        );
    };

    const options = () => {
        const options: SortOption[] = [];
        const sortTypesArray = sortTypesFromConfiguration ? sortTypesFromConfiguration : SearchSortType.getAll();
        sortTypesArray.forEach((type) => {
            options.push({
                value: type.field,
                order: type.order,
                label: t('search.label.sortBy.' + type.field)
            });
        });
        return options;
    };

    if (!docs.allKeys.length) {
        return <div id="no-results-overview-block">{!queryPending && renderNoDocumentsFound()}</div>;
    }

    return (
        <div id="search-results-overview-block">
            {!!docs.allKeys.length && (
                <SortDropdown
                    id="search-sort"
                    value={options().find((option) => option.value === currentSortType.field)}
                    onChange={onSortChange}
                    options={options()}
                />
            )}
        </div>
    );
});
